var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c("img", {
            attrs: {
              alt: "Trivy logo",
              src: require("@/assets/img/trivy-logo.svg"),
              width: "125",
            },
          }),
          _c("hr"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  disabled:
                    !this.scannerEnabled && (!this.baseUrl || !this.apitoken),
                  id: "scannerEnabled",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.scannerEnabled,
                  callback: function ($$v) {
                    _vm.scannerEnabled = $$v
                  },
                  expression: "scannerEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " + _vm._s(_vm.$t("admin.analyzer_trivy_enable")) + "\n    "
          ),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "trivy-baseUrl",
              label: _vm.$t("admin.base_url"),
              "input-group-size": "mb-3",
              rules: "required",
              lazy: "true",
            },
            model: {
              value: _vm.baseUrl,
              callback: function ($$v) {
                _vm.baseUrl = $$v
              },
              expression: "baseUrl",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "trivy-apitoken",
              label: _vm.$t("admin.api_token"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "password",
              lazy: "true",
            },
            model: {
              value: _vm.apitoken,
              callback: function ($$v) {
                _vm.apitoken = $$v
              },
              expression: "apitoken",
            },
          }),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { id: "ignoreUnfixed", color: "primary", label: "" },
                model: {
                  value: _vm.ignoreUnfixed,
                  callback: function ($$v) {
                    _vm.ignoreUnfixed = $$v
                  },
                  expression: "ignoreUnfixed",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.analyzer_trivy_ignore_unfixed")) +
              "\n    "
          ),
          _c("br"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { id: "ignoreUnfixed", color: "primary", label: "" },
                model: {
                  value: _vm.scanLibrary,
                  callback: function ($$v) {
                    _vm.scanLibrary = $$v
                  },
                  expression: "scanLibrary",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.analyzer_trivy_scan_library")) +
              "\n    "
          ),
          _c("br"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { id: "ignoreUnfixed", color: "primary", label: "" },
                model: {
                  value: _vm.scanOs,
                  callback: function ($$v) {
                    _vm.scanOs = $$v
                  },
                  expression: "scanOs",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " + _vm._s(_vm.$t("admin.analyzer_trivy_scan_os")) + "\n  "
          ),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: {
                disabled: !this.baseUrl || !this.apitoken,
                variant: "outline-primary",
              },
              on: { click: _vm.saveChanges },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("message.update")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }